import { Gallery_Navigation_MoreButton_default } from "./chunk-C4YTHYFM.js";
import { GalleryContext, GalleryNavigationContext } from "./chunk-JMBPVZMW.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Gallery/Gallery.Navigation.tsx
import React, { useMemo, Children, cloneElement, useContext, useState } from "react";
import clsx from "clsx";
var GalleryNavigation = _a => {
  var _b = _a,
    {
      children: childrenProp,
      moreButton = /* @__PURE__ */React.createElement(Gallery_Navigation_MoreButton_default, null),
      isNavExpandable = true,
      maxItems: maxItemsProp,
      className
    } = _b,
    rest = __objRest(_b, ["children", "moreButton", "isNavExpandable", "maxItems", "className"]);
  const {
    id,
    totalItems
  } = useContext(GalleryContext);
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const maxItems = useMemo(() => {
    if (!maxItemsProp || maxItemsProp < 1) {
      return totalItems;
    }
    return Math.min(maxItemsProp, totalItems);
  }, [maxItemsProp, totalItems]);
  const context = useMemo(() => ({
    moreButton,
    maxItems,
    isNavExpanded,
    setIsNavExpanded,
    isNavExpandable
  }), [moreButton, maxItems, isNavExpanded, isNavExpandable]);
  const children = useMemo(() => {
    const childrenArray = Children.toArray(childrenProp);
    return {
      always: childrenArray.slice(0, maxItems).map((child, index) => cloneElement(child, {
        itemNumber: index + 1
      })),
      expanded: childrenArray.slice(maxItems).map((child, index) => cloneElement(child, {
        itemNumber: maxItems + index + 1
      }))
    };
  }, [childrenProp, maxItems]);
  return /* @__PURE__ */React.createElement(GalleryNavigationContext.Provider, {
    value: context
  }, /* @__PURE__ */React.createElement("nav", {
    id: "".concat(id, "-navigation"),
    role: "region",
    className: "pd-gallery-navigation"
  }, /* @__PURE__ */React.createElement("ol", __spreadProps(__spreadValues({}, rest), {
    role: "tablist",
    className: clsx("pd-gallery-navigation__items", children.expanded.length !== 0 && "pd-gallery-navigation__items--expandable", className)
  }), children.always, children.expanded.length !== 0 && !isNavExpanded ? moreButton : children.expanded)));
};
var Gallery_Navigation_default = GalleryNavigation;
export { Gallery_Navigation_default };